import React, { useState, useContext, useEffect } from 'react';
import { notification, Modal } from 'antd';
import { UserContext } from '../../App';
import Services from '../../network/Services';
import AddCategoryModal from './AddCategoryModal';
import AgentTree from './AgentTree';
import './AgentsGuidance.css';

export default function AgentsGuidance() {
  const { setLoader } = useContext(UserContext);
  const [api, contextHolder] = notification.useNotification();

  const [categories, setCategories] = useState([]);
  const [nodeTypes, setNodeTypes]   = useState([]);
  const [catModal, setCatModal]     = useState(null); // null | { editData }

  const loggedUserId = sessionStorage?.getItem('loggedUserId');

  const fetchCategories = () => {
    setLoader(true);
    Services.getAgentCategories()
      .then(res => setCategories((res?.data?.data || [])
      ?.filter(c => c.isActive !== false)
    ))
      .finally(() => setLoader(false));
  };

  const fetchNodeTypes = () => {
    Services.getAgentNodeType()
      .then(res => setNodeTypes(res?.data?.data || []));
  };

  useEffect(() => {
    fetchCategories();
    fetchNodeTypes();
  }, []);

  const handleUpsertCategory = async (categoryName, categoryId) => {
    setLoader(true);
    try {
      const res = await Services.upsertAgentCategory({
        categoryId, categoryName, isActive: true, upsertedBy: loggedUserId,
      });
      if (res?.data) {
        api?.success({ message: categoryId === 0 ? 'Category added.' : 'Category updated.', placement: 'topRight' });
        setCatModal(null);
        fetchCategories();
      }
    } catch (err) {
      api?.error({ message: 'Failed to save category.', placement: 'topRight' });
      throw err;
    } finally {
      setLoader(false);
    }
  };

  const handleDeleteCategory = async (categoryId) => {
    const category = categories?.find(c => c.categoryId === categoryId);
    setLoader(true);
    try {
      const res = await Services.deleteWorkflowEntity({
        entityType: 'category',
        entityId: categoryId,
        deletedBy: loggedUserId,
        userId: loggedUserId,
      });
      if (res?.data) {
        api?.success({ message: 'Category deleted.', placement: 'topRight' });
        setCatModal(null);
        fetchCategories();
      }
    } catch (err) {
      api?.error({ message: 'Failed to delete category.', placement: 'topRight' });
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      {contextHolder}
      <div className='ag-wrapper'>
        <div className='ag-header'>
          <h4 className='ag-title'>Agent Module</h4>
          <p className='ag-subtitle'>
            Step-by-step guides to help agents navigate and complete tasks efficiently.
          </p>
        </div>

        <AgentTree
          categories={categories}
          nodeTypes={nodeTypes}
          loggedUserId={loggedUserId}
          onNotify={(msg) => api.success({ message: msg, placement: 'topRight' })}
          onError={(msg) => api.error({ message: msg, placement: 'topRight' })}
          onEditCat={(cat) => setCatModal({ editData: cat })}
          onAddCat={() => setCatModal({ editData: null })}
        />
      </div>

      <AddCategoryModal
        visible={!!catModal}
        onClose={() => setCatModal(null)}
        onSuccess={handleUpsertCategory}
        editData={catModal?.editData}
        onDelete={handleDeleteCategory}
      />
    </>
  );
}
